<template>
  <div class="app-product-information-item-recent">
    <slot name="txtBefore"></slot>
    <ProductInformationSheet :product-information="productInformation" :sheet="productInformation.recentVersion" :show-version="false">
      <template v-for="slot in possibleChildSlotsFor('Recent')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ProductInformationSheet>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import ProductInformationSheet from './Sheet.vue'
import slotProxy from '../../../../mixins/slotProxy'
/**
 * Diese Komponente stellt eine ProductInformation dar, indem nur die letzte Version angezeigt wird
 */
export default {
  components: { ProductInformationSheet },
  mixins: [
    slotProxy()
  ],
  props: {
    productInformation: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  name: 'ProductInformationItemRecent'
}
</script>
